var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5001 13.572L12.0001 21M12.0001 21L4.50006 13.572C4.00536 13.0906 3.6157 12.512 3.3556 11.8726C3.09551 11.2333 2.97062 10.5469 2.98879 9.85693C3.00697 9.16691 3.16782 8.48813 3.46121 7.86333C3.75461 7.23853 4.17419 6.68125 4.69354 6.22657C5.21289 5.7719 5.82076 5.42968 6.47887 5.22147C7.13697 5.01327 7.83106 4.94358 8.51743 5.0168C9.20379 5.09001 9.86756 5.30455 10.4669 5.6469C11.0663 5.98925 11.5883 6.45199 12.0001 7.00599C12.4136 6.45602 12.9362 5.99731 13.5352 5.6586C14.1341 5.31988 14.7966 5.10844 15.481 5.03751C16.1654 4.96658 16.8571 5.03769 17.5128 5.24639C18.1685 5.45508 18.7741 5.79687 19.2916 6.25036C19.8091 6.70385 20.2275 7.25928 20.5205 7.88189C20.8135 8.50449 20.9748 9.18088 20.9944 9.8687C21.0139 10.5565 20.8913 11.241 20.6342 11.8792C20.3771 12.5175 19.991 13.0958 19.5001 13.578L12.0001 21Z",
    stroke: "#2F49D1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.71eab813cf1f389185b6c0b121a4be82.svg";
export { ForwardRef as ReactComponent };